// This flag will disable all aspects of the experiment for every user, we'll only set this to false
// for testing, until we actually release the experiment. We might want to move this flag to stacks later on

// @ts-ignore
import Config from 'Config';

export function funnelExperimentDisabledGlobally() {
  const isEnabled = (Config.Environment.COACHING_FUNNEL_EXPERIMENT_ENABLED === 'true');
  return !isEnabled;
}
